export const getFormName = (name) => (!name ? 'location-form' : name);
